import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  CircularProgress,
  FormLabel,
} from "@mui/material";
import { Scrollbars } from "rc-scrollbars";
import Divider from "@mui/material/Divider";
import NoResultsPublished from "./NoResultsPublished";

import clubImage from "../../../assets/images/club_image.svg";
import Logo1 from "../../../assets/images/Logo1.png";
import Logo2 from "../../../assets/images/Logo2.png";
import Logo3 from "../../../assets/images/Logo3.png";
import Logo4 from "../../../assets/images/Logo4.png";
import ListComponent from "./ListComponent";
import PublicResultsFooter from "./PublicResultsFooter";
import { useLocation } from "react-router-dom";
import {
  BACKEND_BASE_URL,
  EVENT_BANNER_PATH,
  EVENT_lOGO_PATH,
  SERIES_BANNER_PATH,
} from "../../global/constants";
import PublishResultsNoImage from "../../../components/PublishResultsNoImage";
import { encrypt } from "../../global/helperFunctions";
import FooterBottom from "./FooterBottom";
import CompanyLogo from "../../../assets/images/topyacht.svg";

const PublicResults = () => {
  const [seriesList, setSeriesList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [clubName, setClubName] = useState("");
  const [banner, setbanner] = useState("");
  const [logos, setLogos] = useState([]);

  const location = useLocation(); // Access the current location object

  const fetchPublishResults = async () => {
    try {
      // Get query parameters from the URL
      const searchParams = new URLSearchParams(location.search);
      const clubId = searchParams.get("clubId");
      const eventId = searchParams.get("eventId");
      const encryptedClubId = clubId; //encodeURIComponent(encrypt(JSON.stringify(clubId)));
      const encryptedEventId = eventId; // encodeURIComponent(encrypt(JSON.stringify(eventId)));

      // Construct the full URL
      const url =
        `${BACKEND_BASE_URL}api/PublishResults/clubs/list?clubId=` +
        encryptedClubId +
        `&eventId=` +
        encryptedEventId;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log("THE result", result);

      setSeriesList(result.data); // Store API response in state
      if (
        result.data != undefined &&
        result.data != null &&
        result.data.length > 0
      ) {
        setClubName(result.data[0].clubName);
        setbanner(
          result.data[0].banner ? EVENT_BANNER_PATH + result.data[0].banner : ""
        );
        setLogos(
          result.data[0].logos
            ? result.data[0].logos.split(",").map((x) => EVENT_lOGO_PATH + x)
            : []
        );
      }
    } catch (err) {
      setError(err.message); // Handle errors
    } finally {
      setLoading(false); // Mark loading as complete
    }
  };

  useEffect(() => {
    fetchPublishResults(); // Fetch data when component mounts
  }, []);

  const officialNoticeBoardItems = [
    { label: "Race Committee Notices", link: "" },
    { label: "Protests hearings", link: "" },
    { label: "Protests cut off times", link: "" },
    { label: "Protests cut off times", link: "" },
  ];

  const todaysResultsItems = [
    { label: "Rotating Results", link: "" },
    { label: "Results Matrix", link: "" },
    { label: "Results Matrix with Timeout", link: "" },
  ];

  useEffect(() => {
    const isLoggedIn = Boolean(localStorage?.getItem("accessToken"));
    const isPublicResultsPage =
      window.location.pathname.startsWith("/publicresults");

    if (!isLoggedIn || !isPublicResultsPage) return;

    const mainElement = document.querySelector(".ty_application_design main");
    if (!mainElement) return;

    // Check if screen is tablet/mobile (md and below) or desktop (lg and above)
    const isTabletOrMobile = window.innerWidth < 1050; // lg breakpoint in MUI is 1200px

    mainElement.style.setProperty(
      "height",
      isTabletOrMobile ? "calc(100% - 50px)" : "calc(100% - 10px)",
      "important"
    );

    return () => {
      mainElement.style.setProperty(
        "height",
        "calc(100% - 70px)",
        "important"
      );
    };
  }, []);


  return (
    <div className="ty_public_results_main ty_application_design index_results">
       <>
        <Box className="inner_wrapper_pages">
          <Box className="InnerPage_area">
            <Scrollbars
              autoHide
              // autoHeight
              // autoHeightMin={"calc(100vh - 180px)"}
              style={{
                width: "100%",
                height: "100%",
              }}
            >
              {loading ? (
                <CircularProgress sx={{ color: "#fff" }} size={14} />
              ) : (
                <Box className="ty_public_results">
                  <Grid container className="ty_pr_main_container">
                    <Grid
                      item
                      lg={12}
                      md={12}
                      xs={12}
                      sx={{
                        justifyItems: "center",
                        width: "100%",
                        padding: "0",
                      }}
                    >
                      {banner ? (
                        <img
                          src={banner}
                          alt="Club Image"
                          className="ty_pr_club_image"
                        />
                      ) : (
                        <div className="BannerHandler">
                          <PublishResultsNoImage
                            tagName={"Banner"}
                            boxWidth={"20%"}
                            boxHeight={"100px"}
                          />
                        </div>
                      )}
                    </Grid>

                    <Grid
                      item
                      lg={12}
                      md={12}
                      xs={12}
                      sx={{ justifyItems: "center", padding: "0 0.75rem" }}
                    >
                      <Typography
                        className="ty_pr_caption_text"
                        sx={{ margin: "0.75rem 0" }}
                      >
                        Race Results from <>{clubName}</>
                      </Typography>
                    </Grid>

                    {seriesList[0].seriesId === null ? (
                      <Grid
                        item
                        lg={12}
                        md={12}
                        xs={12}
                        sx={{
                          justifyItems: "center",
                          paddingTop: 0,
                          paddingLeft: "0.75rem",
                          paddingRight: "0.75rem",
                        }}
                      >
                        <NoResultsPublished />
                      </Grid>
                    ) : (
                      <Grid
                        item
                        lg={12}
                        md={12}
                        xs={12}
                        pt={1}
                        sx={{
                          justifyItems: "center",
                          paddingTop: "0",
                          paddingLeft: "0.75rem",
                          paddingRight: "0.75rem",
                        }}
                      >
                        <Grid container className="ty_pr_container">
                          <Grid item lg={4} md={4} xs={12} display="none" justifyItems="center">
                            <Box className="ty_pr_Box">
                              <Box className="ty_pr_BoxBody">
                                <Box className="ty_pr_Box_header">
                                  <p variant="h6">Official Notice Board</p>
                                </Box>
                              </Box>
                              <ListComponent />
                            </Box>
                          </Grid>

                          <Grid item lg={6.5} md={6.5} xs={12} justifyItems="center">
                            <Box className="ty_pr_Box">
                              <Box className="ty_pr_BoxBody">
                                <Box className="ty_pr_Box_header">
                                  <p variant="h6">Series</p>
                                </Box>
                              </Box>
                              <ListComponent listItems={seriesList} />
                            </Box>
                          </Grid>

                          <Grid item lg={4} md={4} xs={12} display="none" justifyItems="center">
                            <Box className="ty_pr_Box">
                              <Box className="ty_pr_BoxBody">
                                <Box className="ty_pr_Box_header">
                                  <p variant="h6">Today's Results</p>
                                </Box>
                              </Box>
                              <ListComponent />
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>

                  <Grid container>
                    {logos?.length > 0 ? (
                      <Grid mt={1} item xs={12}>
                        <PublicResultsFooter
                          footerLogos={logos}
                          footerBannerImage={banner}
                        />
                      </Grid>
                    ) : (
                      ""
                    )}

                    <Box
                      sx={{
                        p: 1,
                        width: "100%",
                      }}
                      className="ty_pr_StikcyFooter"
                    >
                      <Typography className="result-by">
                        Results By{" "}
                      </Typography>
                      <img
                        src={CompanyLogo}
                        alt="Banner"
                        style={{
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                  </Grid>
                </Box>
              )}
            </Scrollbars>
          </Box>
        </Box>
    </>
    </div >
  );
};

export default PublicResults;
